import { useEffect } from "react"
import { useDndContext } from "@dnd-kit/core"

import { NucleoFillIcon } from "@productlane/ui"

import type { DragItem } from "./types"
import type { UniqueIdentifier } from "@dnd-kit/core"
import { getArticleDisplayTitle } from "./article-kind"

// dnd-kit measures droppable rects once, at drag start. Collapsing the dragged
// section and springing a group open both move rows after that, so the parent
// calls this to re-measure. Passing an empty id list re-measures everything.
export function MeasureBridge({
	measureRef,
}: {
	measureRef: React.MutableRefObject<((ids: UniqueIdentifier[]) => void) | null>
}) {
	const { measureDroppableContainers } = useDndContext()

	useEffect(() => {
		measureRef.current = measureDroppableContainers
		return () => {
			measureRef.current = null
		}
	}, [measureDroppableContainers, measureRef])

	return null
}

// The row that follows the cursor. It lives in DragOverlay's fixed-position
// portal, so the real row never gets a transform. A transformed row inside the
// sidebar's scroll container adds to that container's scrollable overflow,
// which is what let a dragged group scroll the sidebar without end.
export function DragPreview({ item }: { item: DragItem }) {
	if (item.type === "group") {
		return (
			<div className="flex h-[1.9rem] items-center rounded-md bg-white pl-2 pr-3 text-sm font-medium text-primary shadow-lg ring-1 ring-black/5 dark:bg-gray-850 dark:ring-white/10">
				{item.group.name}
			</div>
		)
	}

	return (
		<div className="flex h-[1.9rem] items-center gap-2.5 rounded-md bg-white pl-2.5 pr-3 text-sm font-medium text-primary shadow-lg ring-1 ring-black/5 dark:bg-gray-850 dark:ring-white/10">
			<NucleoFillIcon icon={item.article.icon} className="size-4 shrink-0" />
			<span className="max-w-52 truncate">
				{getArticleDisplayTitle(item.article)}
			</span>
		</div>
	)
}
